// extracted by mini-css-extract-plugin
export var redoItem = "_ga-1";
export var redoTrigger = "_ga-0";